import React from 'react';
import deepEqual from 'deep-equal';

const deepCompareProps = (
  prevProps: React.PropsWithChildren<any>,
  nextProps: React.PropsWithChildren<any>
) => deepEqual(prevProps, nextProps);

export { deepCompareProps };
